import { SxProps } from '@mui/system';
import React from 'react';
import { H } from '../../Layout';
import QuickFilterAutoItem from './QuickFilterAutoItem';
import type { QuickFilter } from './QuickFilterItem';
import QuickFilterSearchMultiSelectItem from './QuickFilterSearchMultiSelectItem';
import QuickFilterSearchSingleSelectItem from './QuickFilterSearchSingleSelectItem';
import QuickFilterSingleSelectItem from './QuickFilterSingleSelectItem';

type FiltersProps = {
    filters: QuickFilter[];
    onFilterChanged: (filter: QuickFilter) => void;
    requiredFilters?: string[];
    /** Allows automatic switching from default quick filter UI to search-based UI for large option sets. */
    allowAutoSwitchingQuickFilterType?: boolean;
    sx?: SxProps;
};

const QUICK_FILTER_COMPONENTS = {
    SingleSelectFacet: QuickFilterSingleSelectItem,
    SearchMultiSelectFacet: QuickFilterSearchMultiSelectItem,
    SearchSingleSelectFacet: QuickFilterSearchSingleSelectItem
} as const;

export default function QuickFilterList(props: FiltersProps) {
    const { filters, onFilterChanged, requiredFilters = [], allowAutoSwitchingQuickFilterType = true, sx } = props;

    const renderQuickFilterItem = (filter: QuickFilter) => {
        const Component = QUICK_FILTER_COMPONENTS[filter?.displayType] || QuickFilterAutoItem;
        const autoSwitchProps = Component === QuickFilterAutoItem ? { allowAutoSwitchingQuickFilterType } : {};
        return (
            <Component
                key={filter.id}
                requiredFilters={requiredFilters}
                filter={filter}
                onFilterChanged={onFilterChanged}
                sx={sx}
                {...autoSwitchProps}
            />
        );
    };

    return <H sx={{ gap: 1, width: 'fit-content' }}>{filters.map((filter) => renderQuickFilterItem(filter))}</H>;
}
